"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _domainSearchBar = _interopRequireDefault(require("../../../elements/other/domain-search-bar"));
var _comarketingBar = _interopRequireDefault(require("./comarketing-bar"));
var _domainSearch = _interopRequireDefault(require("@site/pattern-library-core/domain-search"));
var _useSticky = require("../../../navigation/other/sticky-stack/use-sticky");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Local Imports
 */

const StickyContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "StickyContainer",
  class: "pl-stjcgpq"
});
const SearchWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SearchWrapper",
  class: "pl-sghxit0"
});

/**
 * TLDSearchBar Component
 *
 * @param {Object} props React props
 * @param {String} props.id TLD Identifier
 * @param {String} props_name TLD Impression Tracking Name
 * @param {Object} props.coMarketingBar Co Marketing Component Properties
 * @param {Object} props.domainSearch Domain Search Component Properties
 * @returns {React.ReactElement} TLDSearchBar Component
 * @public
 */

function TLDSearchBar({
  id,
  _name,
  partial = '',
  coMarketing,
  domainSearch,
  isSticky = false
}) {
  const ref = (0, _react.useRef)(null);
  const {
    isStickyState
  } = (0, _useSticky.useSticky)(`id-${id}`, ref, isSticky);
  return /*#__PURE__*/_react.default.createElement(StickyContainer, {
    ref: ref,
    "data-tld-search-bar": true,
    className: `sticky ${isStickyState}`,
    "data-partial": partial || 'actionAccent2'
  }, /*#__PURE__*/_react.default.createElement(_section.default, {
    id: `id-${id}`,
    _name: _name,
    dataCy: "search-bar",
    verticalPadding: "none",
    verticalMargin: "none"
  }, /*#__PURE__*/_react.default.createElement(SearchWrapper, null, /*#__PURE__*/_react.default.createElement(_domainSearchBar.default, {
    domainSearch: domainSearch,
    partial: partial
  }), coMarketing && /*#__PURE__*/_react.default.createElement(_comarketingBar.default, coMarketing))));
}
var _default = exports.default = TLDSearchBar;
TLDSearchBar.propTypes = {
  _name: _propTypes.default.string,
  id: _propTypes.default.string,
  partial: _propTypes.default.string,
  coMarketing: _propTypes.default.shape(_comarketingBar.default.propTypes),
  domainSearch: _propTypes.default.shape(_domainSearch.default.propTypes),
  isSticky: _propTypes.default.bool
};